import React, { useContext, useEffect, useState } from "react";
import SideNav from "./SideNav";
 
 
import { Context } from "../contexts/AppContext";

import Icons from "../Icons/index";
import { getData } from "../../lib/utils";
import { useParams } from "react-router-dom";
import LinkMedia from "../PropertyList/LinkMedia";
function StudioHome() {

 
console.log("-------------STUDIOHOME JS------------------")
   const { value } = useContext(Context);  
   const [appState, setAppState] = value; 
  const [modalOpen, setModalOpen] = useState(appState.modalData);
  let [temp, setTemp] = useState("VideoPlayerModal");
    const { galleryId } = useParams();
  
   
  let PropertyObj = Icons[temp]; 
  
  
useEffect(() => {
  
  setModalOpen(appState.modalData); // 
}, [appState.modalData]);

  // Fetch data when component mounts or galleryId changes
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getData(`galleries/gallery/${galleryId}`);

        if (response) {
          console.log("HEADINGSIVENAV.JS call get galleries/gallery api", response);

          const obj = {
            name: response.folder?.name || "",
            id: response.folder?._id || "",
            galleries: [response.gallery] || [],
            adminId:response.folder?.adminId,
            backgroundMedia:response?.gallery?.backgroundMedia
          };

          setAppState((prevState) => ({
            ...prevState,
            currentFolderData: obj,
            currentGalleryData:response.gallery,
            videoArr: response.videos || [],
            currentGalleryName: response.gallery?.name || "",
            currentGalleryVideoTitle: response.gallery?.title || "",
            currentGalleryVideoSubTitle: response.gallery?.subtitle || "",
            assetsUrl:response.url
          }));

        
        }
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };

    fetchData(); // Call the async function
  }, [galleryId]); // Ensure effect runs when galleryId changes

 useEffect(() => {
  
   
    if (modalOpen.type === "VideoPlayerModal") {
      PropertyObj = Icons[modalOpen.type];
      setTemp(String("VideoPlayerModal"));
    }
  

    else  if (modalOpen.type === "AddMediaModal") {
      PropertyObj = Icons["AddMediaModal"];
      setTemp(String("AddMediaModal"));
    }
   
  }, [modalOpen?.isOpen]);
  return (
    <>
    <SideNav />
     
    {/* it's use to open modal when we click on video thumbnail button its open modal of general and advance setting where we can change video thumb create chapters*/}
  {modalOpen.isOpen && (
    <div id="MODAL_POPUP">
      <PropertyObj />
    </div>
  )}
    </>
  );
}

export default StudioHome;
